module.exports = __webpack_public_path__ + "img/floor-plan.9857f3e8.png";